import { 
    CREATE_CUSTOMER_FAILURE,
    CREATE_CUSTOMER_REQUEST,
    CREATE_CUSTOMER_RESET,
    CREATE_CUSTOMER_SUCCESS,
    CREATE_SUBSCRIPTION_FAILURE,
    CREATE_SUBSCRIPTION_REQUEST,
    CREATE_SUBSCRIPTION_RESET,
    CREATE_SUBSCRIPTION_SUCCESS,

    CANCEL_SUBSCRIPTION_FAILURE,
    CANCEL_SUBSCRIPTION_REQUEST,
    CANCEL_SUBSCRIPTION_RESET,
    CANCEL_SUBSCRIPTION_SUCCESS,

    UPDATE_SUBSCRIPTION_FAILURE,
    UPDATE_SUBSCRIPTION_REQUEST,
    UPDATE_SUBSCRIPTION_RESET,
    UPDATE_SUBSCRIPTION_SUCCESS,

    RESUME_SUBSCRIPTION_FAILURE,
    RESUME_SUBSCRIPTION_REQUEST,
    RESUME_SUBSCRIPTION_RESET,
    RESUME_SUBSCRIPTION_SUCCESS,

    FETCH_DETAILS_SUBSCRIPTION_FAILURE,
    FETCH_DETAILS_SUBSCRIPTION_REQUEST,
    FETCH_DETAILS_SUBSCRIPTION_RESET,
    FETCH_DETAILS_SUBSCRIPTION_SUCCESS,

    OPEN_MANAGE_SUBSCRIPTION_MODAL,
    CLOSE_MANAGE_SUBSCRIPTION_MODAL,

    OPEN_BUY_TUTORING_HOURS_MODAL,
    CLOSE_BUY_TUTORING_HOURS_MODAL,

    OPEN_BUY_TPC_COURSE_MODAL,
    CLOSE_BUY_TPC_COURSE_MODAL,

    CREATE_TUTORING_HOURS_PAYMENT_FAILURE,
    CREATE_TUTORING_HOURS_PAYMENT_REQUEST,
    CREATE_TUTORING_HOURS_PAYMENT_RESET,
    CREATE_TUTORING_HOURS_PAYMENT_SUCCESS,

    UPDATE_TUTORING_HOURS_AVAILABLE_FAILURE,
    UPDATE_TUTORING_HOURS_AVAILABLE_REQUEST,
    UPDATE_TUTORING_HOURS_AVAILABLE_RESET,
    UPDATE_TUTORING_HOURS_AVAILABLE_SUCCESS,

    CREATE_TPC_COURSE_PAYMENT_FAILURE,
    CREATE_TPC_COURSE_PAYMENT_REQUEST,
    CREATE_TPC_COURSE_PAYMENT_RESET,
    CREATE_TPC_COURSE_PAYMENT_SUCCESS,

    FETCH_PAYMENT_RECORD_FAILURE,
    FETCH_PAYMENT_RECORD_REQUEST,
    FETCH_PAYMENT_RECORD_RESET,
    FETCH_PAYMENT_RECORD_SUCCESS,

    CREATE_ACCESS_PAYMENT_REQUEST,
    CREATE_ACCESS_PAYMENT_SUCCESS,
    CREATE_ACCESS_PAYMENT_FAILURE,
    CREATE_ACCESS_PAYMENT_RESET,

    CONFIRM_ACCESS_PAYMENT_REQUEST,
    CONFIRM_ACCESS_PAYMENT_SUCCESS,
    CONFIRM_ACCESS_PAYMENT_FAILURE,
    CONFIRM_ACCESS_PAYMENT_RESET,

} from "./PaymentsTypes";


const initialCreateCustomerState = {
    createcustomer: [],
    loading : false
}

export const createCustomerReducer = (state = initialCreateCustomerState, action) => {
    switch(action.type){
        case CREATE_CUSTOMER_RESET:
            return {
                loading: false,
                createcustomer: []
            }
        case CREATE_CUSTOMER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CREATE_CUSTOMER_SUCCESS:
            return {
                loading: false,
                createcustomer: [action.payload]
            }
        case CREATE_CUSTOMER_FAILURE:
            return {
                loading : false,
                createcustomer : [],
                error: action.payload
            }
        default: return state;
    }
}


const initialCreateSubscriptionState = {
    createsubscription: [],
    loading : false
}

export const createSubscriptionReducer = (state = initialCreateSubscriptionState, action) => {
    switch(action.type){
        case CREATE_SUBSCRIPTION_RESET:
            return {
                loading: false,
                createsubscription: []
            }
        case CREATE_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CREATE_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                createsubscription: [action.payload]
            }
        case CREATE_SUBSCRIPTION_FAILURE:
            return {
                loading : false,
                createsubscription : [],
                error: action.payload
            }
        default: return state;
    }
}

const initialCancelSubscriptionState = {
    cancelsubscription: [],
    loading : false
}

export const cancelSubscriptionReducer = (state = initialCancelSubscriptionState, action) => {
    switch(action.type){
        case CANCEL_SUBSCRIPTION_RESET:
            return {
                loading: false,
                cancelsubscription: []
            }
        case CANCEL_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CANCEL_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                cancelsubscription: [action.payload]
            }
        case CANCEL_SUBSCRIPTION_FAILURE:
            return {
                loading : false,
                cancelsubscription : [],
                error: action.payload
            }
        default: return state;
    }
}

const initialUpdateSubscriptionState = {
    updatesubscription: [],
    loading : false
}

export const updateSubscriptionReducer = (state = initialUpdateSubscriptionState, action) => {
    switch(action.type){
        case UPDATE_SUBSCRIPTION_RESET:
            return {
                loading: false,
                updatesubscription: []
            }
        case UPDATE_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case UPDATE_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                updatesubscription: [action.payload]
            }
        case UPDATE_SUBSCRIPTION_FAILURE:
            return {
                loading : false,
                updatesubscription : [],
                error: action.payload
            }
        default: return state;
    }
}



const initialModalManageSubscriptionState = {
    status: false
}


export const manageSubscriptionModalStatusReducer = (state = initialModalManageSubscriptionState, action) => {
    switch (action.type) {
        case OPEN_MANAGE_SUBSCRIPTION_MODAL:
            return {
                status : true
            }
        case CLOSE_MANAGE_SUBSCRIPTION_MODAL:
            return {
                status : false
            }
        default: return state;
    }
}

const initialResumeSubscriptionState = {
    resumesubscription: [],
    loading : false
}

export const resumeSubscriptionReducer = (state = initialResumeSubscriptionState, action) => {
    switch(action.type){
        case RESUME_SUBSCRIPTION_RESET:
            return {
                loading: false,
                resumesubscription: []
            }
        case RESUME_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case RESUME_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                resumesubscription: [action.payload]
            }
        case RESUME_SUBSCRIPTION_FAILURE:
            return {
                loading : false,
                resumesubscription : [],
                error: action.payload
            }
        default: return state;
    }
}


const initialFetchDetailsSubscriptionState = {
    loading: false,
    fetchdetailssubscription: [],
}

export const fetchDetailsSubscriptionReducer = (state = initialFetchDetailsSubscriptionState, action) => {
    switch (action.type) {
        case FETCH_DETAILS_SUBSCRIPTION_RESET:
            return {
                loading: false,
                fetchdetailssubscription: [],
            }
        case FETCH_DETAILS_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_DETAILS_SUBSCRIPTION_SUCCESS:
            return {
                loading: false,
                fetchdetailssubscription: [action.payload]
            }
        case FETCH_DETAILS_SUBSCRIPTION_FAILURE:
            return {
                loading: false,
                fetchdetailssubscription: [],
                error: action.payload
            }
        default: return state;
    }
}

const initialModalBuyTutoringHoursState = {
    status: false
}


export const buyTutoringHoursModalStatusReducer = (state = initialModalBuyTutoringHoursState, action) => {
    switch (action.type) {
        case OPEN_BUY_TUTORING_HOURS_MODAL:
            return {
                status : true
            }
        case CLOSE_BUY_TUTORING_HOURS_MODAL:
            return {
                status : false
            }
        default: return state;
    }
}


const initialcreateTutoringHoursPaymentState = {
    createtutoringhourspayment: [],
    loading : false
}

export const createTutoringHoursPaymentReducer = (state = initialcreateTutoringHoursPaymentState, action) => {
    switch(action.type){
        case CREATE_TUTORING_HOURS_PAYMENT_RESET:
            return {
                loading: false,
                createtutoringhourspayment: []
            }
        case CREATE_TUTORING_HOURS_PAYMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CREATE_TUTORING_HOURS_PAYMENT_SUCCESS:
            return {
                loading: false,
                createtutoringhourspayment: [action.payload]
            }
        case CREATE_TUTORING_HOURS_PAYMENT_FAILURE:
            return {
                loading : false,
                createtutoringhourspayment : [],
                error: action.payload
            }
        default: return state;
    }
}


const initialUpdateTutoringHoursAvailableState = {
    updatetutoringhoursavailable: [],
    loading : false
}

export const updateTutoringHoursAvailableReducer = (state = initialUpdateTutoringHoursAvailableState, action) => {
    switch(action.type){
        case UPDATE_TUTORING_HOURS_AVAILABLE_RESET:
            return {
                loading: false,
                updatetutoringhoursavailable: []
            }
        case UPDATE_TUTORING_HOURS_AVAILABLE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case UPDATE_TUTORING_HOURS_AVAILABLE_SUCCESS:
            return {
                loading: false,
                updatetutoringhoursavailable: [action.payload]
            }
        case UPDATE_TUTORING_HOURS_AVAILABLE_FAILURE:
            return {
                loading : false,
                updatetutoringhoursavailable : [],
                error: action.payload
            }
        default: return state;
    }
}


const initialcreateTpcCoursePaymentState = {
    createtpccoursepayment: [],
    loading : false
}

export const createTpcCoursePaymentReducer = (state = initialcreateTpcCoursePaymentState, action) => {
    switch(action.type){
        case CREATE_TPC_COURSE_PAYMENT_RESET:
            return {
                loading: false,
                createtpccoursepayment: []
            }
        case CREATE_TPC_COURSE_PAYMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CREATE_TPC_COURSE_PAYMENT_SUCCESS:
            return {
                loading: false,
                createtpccoursepayment: [action.payload]
            }
        case CREATE_TPC_COURSE_PAYMENT_FAILURE:
            return {
                loading : false,
                createtpccoursepayment : [],
                error: action.payload
            }
        default: return state;
    }
}

const initialFetchPaymentRecordState = {
    loading: false,
    fetchpaymentrecord: [],
}

export const fetchPaymentRecordReducer = (state = initialFetchPaymentRecordState, action) => {
    switch (action.type) {
        case FETCH_PAYMENT_RECORD_RESET:
            return {
                loading: false,
                fetchpaymentrecord: [],
            }
        case FETCH_PAYMENT_RECORD_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_PAYMENT_RECORD_SUCCESS:
            return {
                loading: false,
                fetchpaymentrecord: [action.payload]
            }
        case FETCH_PAYMENT_RECORD_FAILURE:
            return {
                loading: false,
                fetchpaymentrecord: [],
                error: action.payload
            }
        default: return state;
    }
}

// One-time Access Payment Reducers
const initialCreateAccessPaymentState = {
    data: null,
    loading: false,
    error: null,
    success: false
}

export const createAccessPaymentReducer = (state = initialCreateAccessPaymentState, action) => {
    switch (action.type) {
        case CREATE_ACCESS_PAYMENT_RESET:
            return initialCreateAccessPaymentState
        case CREATE_ACCESS_PAYMENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case CREATE_ACCESS_PAYMENT_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: null,
                success: true
            }
        case CREATE_ACCESS_PAYMENT_FAILURE:
            return {
                loading: false,
                data: null,
                error: action.payload,
                success: false
            }
        default: return state;
    }
}

const initialConfirmAccessPaymentState = {
    data: null,
    loading: false,
    error: null,
    success: false
}

export const confirmAccessPaymentReducer = (state = initialConfirmAccessPaymentState, action) => {
    switch (action.type) {
        case CONFIRM_ACCESS_PAYMENT_RESET:
            return initialConfirmAccessPaymentState
        case CONFIRM_ACCESS_PAYMENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case CONFIRM_ACCESS_PAYMENT_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: null,
                success: true
            }
        case CONFIRM_ACCESS_PAYMENT_FAILURE:
            return {
                loading: false,
                data: null,
                error: action.payload,
                success: false
            }
        default: return state;
    }
}

